/**
 * 个人中心类目（服务商页）
 * 与 web/src/api/user.js 一致
 */
import { fetchWithAuth } from '../utils/request.js';
import { getApiUrl } from '../config/api.js';

export async function getPersonalCenterCategory() {
  const res = await fetchWithAuth(getApiUrl('personalCenterCategory'));
  const json = await res.json();
  if (json.code === 200) {
    const list = Array.isArray(json.data) ? json.data : [];
    return { success: true, data: list };
  }
  const requireAuth =
    res.status === 401 || (json.message && /请先登录|未登录|登录过期/i.test(json.message));
  return {
    success: false,
    message: json.message || '获取个人中心信息失败',
    requireAuth
  };
}

/**
 * GET /api/index/personalCenterCategoryList?category_id=
 */
export async function getPersonalCenterCategoryList(categoryId) {
  const base = getApiUrl('personalCenterCategoryList');
  const qs = new URLSearchParams({ category_id: String(categoryId) });
  const url = `${base}?${qs.toString()}`;
  const res = await fetchWithAuth(url);
  const json = await res.json();
  if (json.code === 200) {
    return { success: true, data: json.data };
  }
  const requireAuth =
    res.status === 401 || (json.message && /请先登录|未登录|登录过期/i.test(json.message));
  return {
    success: false,
    message: json.message || '获取分类内容失败',
    requireAuth
  };
}
